// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".setting-btn[data-v-f54c4258]{min-width:95px}.schedule-btn[data-v-f54c4258]{min-width:240px}.box-body .tab-title[data-v-f54c4258]{height:25px}.box-body .noreply-badge-content[data-v-f54c4258]{margin-top:-5px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
